document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-correnva-gallery]').forEach((gallery) => {
    const stage = gallery.querySelector('[data-gallery-stage]');
    const thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    if (!stage || !thumbs.length) return;

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const next = gallery.querySelector(`#${CSS.escape(thumb.getAttribute('aria-controls'))}`);
        if (!next) return;
        stage.querySelectorAll('[data-gallery-panel]').forEach((panel) => { panel.hidden = panel !== next; });
        thumbs.forEach((item) => item.setAttribute('aria-current', item === thumb ? 'true' : 'false'));
        next.focus({ preventScroll: true });
      });
    });
  });

  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const variantSelect = form.querySelector('[name="id"]');
    const price = document.querySelector('[data-product-price]');
    if (!variantSelect || !price) return;
    variantSelect.addEventListener('change', () => {
      const option = variantSelect.options[variantSelect.selectedIndex];
      if (option.dataset.price) price.textContent = option.dataset.price;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variantSelect.value);
      window.history.replaceState({}, '', url);
    });
  });
});
